import $ from 'jquery'

$(function($) {
   $(".no-js-fallback").hide();
   $(".journey-choice").click(({currentTarget}) => {
      let $journeyChoices = $(".journey-choice");
      $journeyChoices.removeClass("selected");
      $journeyChoices.attr("aria-checked", "false");
      $(currentTarget).addClass("selected");
      $(currentTarget).attr("aria-checked", "true");
      $(currentTarget).find(".no-js-fallback input").prop("checked", true);
   });
   $(".journey-choice").keyup(({key, currentTarget}) => {
      if (key === "ArrowDown") {
         let next = $(currentTarget).next(".journey-choice");
         if (next) {
            $(next).focus();
            $(next).click();
         }
      } else if (key === "ArrowUp") {
         let prev = $(currentTarget).prev(".journey-choice");
         if (prev) {
            $(prev).focus();
            $(prev).click();
         }
      } else if (key === "Enter") {
         $(currentTarget).click();
      }
   });
   
   $(".journey-choice .no-js-fallback input").each((i, e) => {
      console.log($(e));
      console.log($(e).prop("checked"));
      if ($(e).prop("checked")) {
         $(e).parents(".journey-choice").addClass("selected");
      }
   });
});
